module.exports = __webpack_public_path__ + "static/media/Odometerreading.548d76fb.png";